let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("5whKV")]).then(() => parcelRequire('8KP6j'));